import React, {Component, useCallback, useEffect} from 'react';
import {Button, Col, Container, Row} from 'reactstrap';
import PageMeta from 'components/PageMeta';
import Video from 'components/Video';
import CheckoutButton from 'components/CheckoutButton';
import Footer from 'components/Elements/Footer';
import logoTrees from 'static/logo/logo-trees-for-future-white.png';
import uhcLogo from 'static/logo/frn-uhc-logo.svg';
import uhcProductImage from 'static/uhc21-product.jpg';
import SpeakersGroupByCollection from 'components/Uhc/UhcSpeaker';
import {SalesDisclaimer, UhcUpsell} from 'components/SalesCta';
import Section, {SectionImage} from 'components/Elements/Section';
import useBeacon from 'utils/useBeacon';
import IconList, {IconListItem} from 'components/Elements/IconList';
import {TestimonialCircle} from 'components/Testimonial';
import {faCartPlus} from '@fortawesome/pro-light-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

export default function ({product = 'ff', ...props}) {
  useBeacon();
  return (
    <div className="page page-nosocial">
      <PageMeta title="UHC Upsell" description="UHC upsell page" />

      <div className="page-content">
        <Section
          id="section-uhc-header"
          className="section-angle-first"
          innerClass="text-white text-center"
          color="black"
        >
          <Container>
            <Row className="mb-4">
              <Col>
                <h3 className="section-heading mb-2">
                  {
                    {
                      ff: (
                        <>
                          A Special, One-Time Offer For Our <br className="d-none d-xl-block" />
                          <i>Fantastic Fungi Impact Kit</i> Community
                        </>
                      ),
                      hhc: (
                        <>
                          Thank you for joining <i>Healthy Heart!</i>
                        </>
                      )
                    }[product]
                  }
                </h3>
                <h5 className="text-400 m-0">
                  <i>
                    One quick thing before you go. <br className="d-none d-sm-block d-lg-none" />
                    You’ll never see this opportunity again.
                  </i>
                </h5>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col lg="10" className="video-col px-0 px-sm-3">
                <Video
                  url={
                    {
                      ff: 'https://www.youtube.com/watch?v=2VJRwmU_cVA',
                      hhc: 'https://www.youtube.com/watch?v=QEuhg6Wz_cQ'
                    }[product]
                  }
                  label={{ff: 'FF - UHC Upsell', hhc: 'HHC - UHC Upsell'}[product]}
                />
              </Col>
            </Row>

            {product === 'ff' ? (
              <Row>
                <Col>
                  <h4 className="text-center mt-4">
                    If one of your goals in getting the Impact Kit <br className="d-none d-xl-block" />
                    is improving your own health, this is for you.
                  </h4>
                </Col>
              </Row>
            ) : null}
          </Container>
        </Section>

        {product === 'ff' ? (
          <Section id="section-uhc-frn" color="white" innerClass="text-center">
            <Container>
              <Row className="justify-content-center">
                <Col lg="10">
                  <img
                    className="mb-4"
                    src="https://cdn.foodrevolution.org/global/frn-logo.svg"
                    style={{maxHeight: '100px'}}
                  />
                  <h4 className="section-heading">
                    <i>What is Food Revolution Network?</i>
                  </h4>
                  <p>
                    For over a decade, we’ve been at the forefront of the healthy living movement. We and our 700,000+
                    members are committed to healthy, ethical, and sustainable food for all. We’ve partnered with Louie
                    and the <i>Fantastic Fungi</i> team to bring this film into the world and to create and share the
                    Impact Kit.
                  </p>
                  <p>
                    We want to make sure you know how to eat to prevent and reverse disease — and transform how you look
                    and feel each day.
                  </p>
                </Col>
              </Row>
            </Container>
          </Section>
        ) : null}

        <SectionImage
          id="section-uhc-lifespan-2"
          imgPosition="left"
          imgUrl={require('static/backgrounds/1241736799.jpg')}
          color="light-gray"
        >
          <h3 className="section-heading">What do people with the longest lifespan have in common?</h3>
          <h5 className="mt-0">
            The people with the <i>longest lifespans</i> know how to live and what to eat to:
          </h5>
          <IconList>
            <IconListItem>
              Live an exceptionally healthy life without the common diseases that afflict masses of people in other
              areas of the world.
            </IconListItem>
            <IconListItem>
              Avoid the stress of crushing medical debt, insurance headaches, and a calendar full of nonstop doctor’s
              appointments.
            </IconListItem>
            <IconListItem>
              Say goodbye to sickness and hello to health — without an armload of expensive supplements.
            </IconListItem>
            <IconListItem>Stay at their ideal weight for life, without even thinking about it.</IconListItem>
            <IconListItem>
              Enjoy energy all day without depending on caffeine, sugar, or other stimulants. (And fall asleep easily at
              night!)
            </IconListItem>
          </IconList>
        </SectionImage>

        <Section id="section-uhc-info" className="section-uhc-info" innerClass="text-center" color="white">
          <Container>
            <Row>
              <Col>
                {
                  {
                    ff: (
                      <>
                        <h5 className="section-heading">
                          Food Revolution Network’s co-founder, 2-million-copy <br className="d-none d-xl-block" />
                          bestselling author John Robbins, has interviewed more than 100{' '}
                          <br className="d-none d-xl-block" />
                          of the top food experts on the planet and delivered their cutting-edge{' '}
                          <br className="d-none d-xl-block" />
                          wisdom to millions in the world-famous Food Revolution Summit.
                        </h5>
                        <p>
                          <b>
                            Now’s your chance to get 20 of our best and most popular{' '}
                            <br className="d-none d-xl-block" />
                            health-boosting interviews in the Ultimate Health Collection.
                          </b>
                        </p>
                      </>
                    ),
                    hhc: (
                      <>
                        <h2 className="section-heading mb-3">
                          A Special, One-Time Offer <br className="d-none d-xl-block" />
                          For Healthy Heart Participants
                        </h2>
                        <p>
                          <i>This opportunity won’t be available again at this price after you close this page.</i>
                        </p>
                        <h4 className="mb-3">
                          For over a decade, Food Revolution Network has worked <br className="d-none d-xl-block" />
                          with the world’s foremost experts in healthy living.
                        </h4>
                        <h4 className="mt-0 mb-3">
                          We’ve compiled 20 of our best health-centric interviews <br className="d-none d-xl-block" />
                          in the Ultimate Health Collection.
                        </h4>
                      </>
                    )
                  }[product]
                }
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col md="10" lg="8" xl="6">
                <img src={uhcLogo} />
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col>
                <h4 className="text-400 mt-3">Add the Ultimate Health Collection to your cart now for $47</h4>
                {{ff: null, hhc: <p>Get the best health of your life.</p>}[product]}
              </Col>
            </Row>
          </Container>
        </Section>

        <Section id="section-uhc-offer-1" color="gradient-indigo-purple-right">
          <Container>
            <Row>
              <Col>
                <UhcUpsell />
              </Col>
            </Row>
          </Container>
        </Section>

        <Section id="section-uhc-about" color="light-gray">
          <Container>
            <Row className="justify-content-center">
              <Col>
                <h2 className="section-heading text-center">
                  About the Ultimate <br className="d-none d-sm-block d-lg-none" />
                  Health Collection
                </h2>
                <h4 className="text-center mt-0">
                  Ready to get the top insights for lasting health? <br className="d-none d-lg-block" />
                  Make it happen with the help of John Robbins <br className="d-none d-lg-block" />
                  and his unmatched interviews with the <br className="d-none d-lg-block" />
                  world’s top natural health experts.
                </h4>

                <div className="background-white rounded box-shadow-black-25 p-4 p-lg-5 my-5">
                  <Row className="align-items-center justify-content-center">
                    <Col lg="4" className="text-center order-lg-2 mb-4 mb-lg-0">
                      <img
                        className="rounded-circle"
                        src={require('static/speaker/johnrobbins-headshot.jpg')}
                        style={{maxHeight: '250px'}}
                      />
                    </Col>
                    <Col lg="8" className="order-lg-1">
                      <p>Hi, I’m John Robbins.</p>
                      <p>
                        For over 30 years, I’ve been helping people get the best health of their life. Between my
                        multi-million bestselling books like <i>Diet For A New America,</i> co-founding Food Revolution
                        Network, exposing the truth about the industrial food complex, and conducting hundreds of
                        interviews with world-renowned health revolutionaries, I know what it takes to create lasting
                        health.
                      </p>
                    </Col>
                  </Row>
                  <p>
                    The Ultimate Health Collection includes 20 interviews, each with downloadable MP3s and full written
                    transcripts. Soak up wisdom in this curated collection from some of{' '}
                    <b>the world’s top health experts,</b> including multiple <i>New York Times</i> bestselling authors
                    like Tony Robbins and Michael Pollan.
                  </p>
                  <p>
                    <b>Do you need the Utlimate Health Collection to get and stay healthy?</b>
                  </p>
                  <p>
                    No, only if you want to do so in the quickest, least-expensive, and most enjoyable way possible —
                    while avoiding the mistakes and pitfalls that happen when you try to figure it out by yourself.
                  </p>
                  <p>
                    <b>Most people can get the basics down: drink water, don’t smoke, don’t eat fast food.</b>
                  </p>
                  <p>
                    <b>
                      But how do you get <i>extraordinary</i> health?
                    </b>{' '}
                    What’s it take to avoid disease, increase energy, live longer, improve immunity, and stay at a
                    healthy weight? What are the secrets of people who live in the world’s Blue Zones with the longest
                    lifespans?
                  </p>
                  <p>
                    That’s why for over a decade, I’ve interviewed the{' '}
                    <b>top visionaries who are leading the charge towards a healthier future for all of us.</b> We’ve
                    curated the special Ultimate Health Collection to bring you the very best of those interviews.
                  </p>
                  <p>
                    The only other way to buy this beloved collection would be to purchase all of our past Food
                    Revolution Summits and to spend more than $1,500 in the process. But right now (and now only), you
                    can get the Ultimate Health Collection for a mere fraction of that cost — just $47!
                  </p>
                </div>
                <div className="text-center">
                  <CheckoutButton className="offer-box-button offer-box-button-upsell">
                    <FontAwesomeIcon className="mr-2" icon={faCartPlus} /> Yes, Add to Order
                  </CheckoutButton>
                  <SalesDisclaimer />
                </div>
              </Col>
            </Row>
          </Container>
        </Section>

        <Section id="section-uhc-testimonials" color="white">
          <Container>
            <Row>
              <Col>
                <h2 className="section-heading text-center mb-5">
                  What People Are Saying About <br className="d-none d-xl-block" />
                  Food Revolution Network Interviews
                </h2>
                <TestimonialCircle id="uhc-rajiv-b" />
                <hr className="my-5" />
                <TestimonialCircle id="uhc-ginny-o" imgPosition="right" />
                <hr className="my-5" />
                <TestimonialCircle id="uhc-ann-s" />
                <p className="text-center text-16 mt-5 mb-0">
                  <i>These testimonials reflect people’s unique experience. Your specific experience will vary.</i>
                </p>
              </Col>
            </Row>
          </Container>
        </Section>

        <SectionImage
          id="section-uhc-imagine-1"
          imgPosition="right"
          imgUrl={require('static/backgrounds/920522262.jpg')}
          color="light-gray"
        >
          <Container>
            <Row>
              <Col>
                <h5 className="section-heading">Imagine being able to:</h5>
                <IconList>
                  <IconListItem>Live longer</IconListItem>
                  <IconListItem>Live better</IconListItem>
                  <IconListItem>Beat cancer</IconListItem>
                  <IconListItem>Achieve peak performance</IconListItem>
                  <IconListItem>Prevent Alzheimer’s</IconListItem>
                  <IconListItem>Master the psychology of eating</IconListItem>
                  <IconListItem>Use food to improve your immunity</IconListItem>
                  <IconListItem>Shed excess pounds</IconListItem>
                </IconList>
              </Col>
            </Row>
          </Container>
        </SectionImage>

        <SectionImage
          id="section-uhc-imagine-2"
          imgPosition="left"
          imgUrl={require('static/backgrounds/1288965935.jpg')}
          color="light-gray"
        >
          <Container>
            <Row>
              <Col>
                <IconList className="mt-0">
                  <IconListItem>Shed excess pounds</IconListItem>
                  <IconListItem>Feel better</IconListItem>
                  <IconListItem>Sleep deeply</IconListItem>
                  <IconListItem>Nourish yourself</IconListItem>
                  <IconListItem>End inflammation</IconListItem>
                  <IconListItem>Quit sugar</IconListItem>
                  <IconListItem>Love your body exactly as it is</IconListItem>
                  <IconListItem>Enjoy incredible digestion</IconListItem>
                  <IconListItem>Share what you learn with your loved ones</IconListItem>
                </IconList>
              </Col>
            </Row>
          </Container>
        </SectionImage>

        <Section id="section-uhc-speakers" color="white">
          <Container>
            <Row>
              <Col>
                <h2 className="section-heading text-center mb-5">Learn From These Top Health Experts</h2>
              </Col>
            </Row>
            <Row>
              <SpeakersGroupByCollection />
            </Row>
          </Container>
        </Section>

        <Section id="section-uhc-testimonials-2" color="light-gray">
          <Container>
            <Row>
              <Col>
                <TestimonialCircle id="uhc-myra-a" />
                <hr className="my-5" />
                <TestimonialCircle id="uhc-molly-s" imgPosition="right" />
              </Col>
            </Row>
          </Container>
        </Section>

        <Section
          id="section-uhc-offer-2"
          color="gradient-indigo-purple-right"
          className="section-angle-last"
          angle="none"
        >
          <Container>
            <Row>
              <Col>
                <UhcUpsell />
              </Col>
            </Row>
          </Container>
        </Section>
      </div>

      <Footer />
    </div>
  );
}
